import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { Box, Chip, Tooltip } from '@mui/material';
import FilterTable from '../../../../atoms/TableComponent/FilterTable/FilterTable';
import axiosInstance from '../../../../lib/axios';

export default function HKTaskTable() {
    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    const permissions = usePermissions("Task Master");
    const { AddRec = "0" } = permissions || {};

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post(
                'MstHkTask/getMstHkTaskDashBoard',
                {
                    start: 1,
                    PageSize: 1,
                    SearchText: ""
                }
            );
            if (response.data.Status === 0) {
                const formattedData = response.data.Data.map(hkTask => ({
                    ...hkTask,
                    HkTaskName: hkTask.HkTaskName || '',
                    Abrv: hkTask.Abrv || '',
                    Remark: hkTask.Remark || '',
                    Status: hkTask.Status == null ? '' : (hkTask.Status == 1 ? 'Active' : 'Inactive'),
                }));
                setRows(formattedData);
            } else {
                setRows([]);
            }
        } catch (error) {
            console.error('Error while fetching data:', error);
        }
        finally {
            setIsLoading(false);
        }
    };

    const handlePermittedClick = () => {
        if (AddRec === "1") {
            handleClick();
        }
    };

    const handleClick = () => {
        navigate('/hktaskmaster', { state: { mode: "add" } });
    };

    const handleHomeClick = () => {
        navigate('/dashboard');
    };

    const handleLocationclick = () => {
        navigate('/masters/operations');
    };

    const handleRowDoubleClick = (params) => {
        const hkTaskId = params?.data?.HkTaskId;
        if (hkTaskId) {
            navigate('/hktaskmaster', { state: { HkTaskId: hkTaskId, mode: 'view' } });
        }
    };

    const TruncatedCellRenderer = (props) => {
        const [isOverflowed, setIsOverflowed] = useState(false);
        const cellRef = React.useRef(null);

        useEffect(() => {
            if (cellRef.current) {
                const isTextOverflowed =
                    cellRef.current.scrollWidth > cellRef.current.clientWidth ||
                    (props.value && props.value.length > 20);
                setIsOverflowed(isTextOverflowed);
            }
        }, [props.value]);

        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

        return (
            <div
                ref={cellRef}
                className="truncated-cell"
                style={{ width: '100%' }}
            >
                {isOverflowed ? (
                    <Tooltip title={cellValue} arrow>
                        <div>{cellValue}</div>
                    </Tooltip>
                ) : (
                    <div>{cellValue}</div>
                )}
            </div>
        );
    };

    const StatusCellRenderer = (props) => {
        const getStatusColor = (status) => {
            switch (status) {
                case 'Active':
                    return '#4caf50';
                case 'Inactive':
                    return '#f44336';
                default:
                    return '#f44336';
            }
        };

        return (
            <Tooltip title={props.value} arrow>
                <Chip
                    label={props.value}
                    className="status-chip"
                    sx={{
                        backgroundColor: getStatusColor(props.value),
                        color: 'white',
                        width: '100%',
                        maxWidth: '100px',
                    }}
                />
            </Tooltip>
        );
    };

    const columnDefs = [
        { headerName: 'Sr.No.', field: 'RowNum', width: 60, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Hk Task', field: 'HkTaskName', minWidth: 250, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Abbrivation', field: 'Abrv', minWidth: 350, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Remark', field: 'Remark', minWidth: 700, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer, },
        { headerName: 'Status', field: 'Status', width: 100, filter: 'agTextColumnFilter', cellRenderer: StatusCellRenderer },
    ];

    return (
        <Box sx={{ height: '90vh' }}>
            <FilterTable
                columnDefs={columnDefs}
                rowData={rows}
                onRowDoubleClicked={handleRowDoubleClick}
                isLoading={isLoading}
                onHomeClick={handleHomeClick}
                onParentClick={handleLocationclick}
                breadcrumbParentLabel="Operations"
                breadcrumbCurrentLabel="Task Master"
                onAddClick={handlePermittedClick}
                hasAddPermission={AddRec === "1"}
            />
        </Box>
    );
}
